import React, { Component } from "react";
import { request } from "../../util/APIUtils";
import { API_BASE_URL } from "../../constants";
import UserForm from "../user/UserForm";

class WpUserList extends Component {
    constructor(props) {
      super(props);
      this.state = {
        wpUserList: [],
        isModalOpen: false,
        error: null,
        loading: false,
        page: 0,
        size: 10,
        nameFilter: "",
        isUserFormOpen: false
      };
    }
    componentDidMount() {
        this.listWpUser(this.state.page, this.state.size);
       // this.handleUpdateWpUserStatus(this.state.page,this.state.size);
      }


      handleUpdateWpUserStatus = (id, newStatus) => {
            const token = localStorage.getItem("accessToken");
            const apiUrl = API_BASE_URL + `/wpuser/status/${id}`;

            fetch(apiUrl, {
              method: "PUT",
              headers: {
                Authorization: "Bearer " + token,
                "Content-Type": "application/json",
              },
              body: JSON.stringify({
                wpUserStatus: newStatus,
              }),
            })
              .then((response) => {
                if (!response.ok) {
                  throw new Error("Network response was not ok");
                }
                return response.json();
              })
              .then((updatedWpUser) => {
                this.setState((prevState) => ({
                  wpUserList: prevState.wpUserList.map((wpUser) => {
                    if (wpUser.id === id) {
                      return updatedWpUser;
                    }
                    return wpUser;
                    
                  }),
                  
                }));
              })
              alert("başarıyla güncellendi")
              this.props.history.push("/wpKullanıcıListesi")


              .catch((error) => {
                console.error("Hata:", error.message);
              });
};

      handleUserFormOpen = () => {
        this.setState({ isUserFormOpen: true });
      };
    
      handleUserFormClose = () => {
        this.setState({ isUserFormOpen: false });
      };
      
    
      handleNameFilterChange = (event) => {
        this.setState({ nameFilter: event.target.value });
      };

   
      listWpUser(page, size, nameFilter) {
    let self = this;
    let url = API_BASE_URL + `/wpuser/all`;

    if (nameFilter) {
      url += `/shift-requests?name=${nameFilter}`; //?? buraya bak 
    }

    let params = {
      url,
      method: "GET",
    };
    self.setState({ loading: true });
    request(params)
      .then(function (response) {
        self.setState({
            wpUserList: response.data,
          loading: false,
        });
      })
      .catch(function (error) {
        self.setState({ loading: false, error: "Failed to fetch Talep." });
      });
  }

  openModal = () => {
    this.setState({ isModalOpen: true });
  };
 closeModal = () => {
    this.setState({ isModalOpen: false,});
  };

  handleSubmitWpUser = (newWpUser) => {
    const token = localStorage.getItem("accessToken");
    const apiUrl = API_BASE_URL + "/wpuser/save-user";

    this.setState({ loading: true });

    request({
      url: apiUrl,
      method: "POST",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
      data: JSON.stringify(newWpUser),
    })
      .then((response) => {
        this.setState((prevState) => ({
            wpUserList: [...prevState.wpUserList, response.data],
          loading: false,
          isModalOpen: false,
          error: null,
        }));
      })
      .catch((error) => {
        this.setState({
          loading: false,
          error: "Hatalı veya eksik alanlar var!",
        });
        console.error("Fetch işlemi sırasında bir sorun oluştu:", error.message);
      });
  };

  handleDeleteWpUser = (id) => {
    const token = localStorage.getItem("accessToken");
    const apiUrl = API_BASE_URL + `/wpuser/${id}`;

    fetch(apiUrl, {
      method: "DELETE",
      headers: {
        Authorization: "Bearer " + token,
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        this.setState((prevState) => ({
            wpUserList: prevState.wpUserList.filter((wpUserList) => wpUserList.id !== id),
        }));
      })
      .catch((error) => {
        console.error("There was a problem with the fetch operation:", error.message);
      });
  };
  handleFilter = () => {
    const { nameFilter } = this.state;
    this.listTalep(0, this.state.size, nameFilter);
  };
  clearNameFilter = () => {
    this.setState({ nameFilter: "" }, () => {
      this.listWpUser(0, this.state.size, this.state.nameFilter);
    });
  };
 
  render() {
    const {
      wpUserList,
      loading,
      error,
      nameFilter,

    } = this.state;
    return (
        <div className="nobet-talep-container">
          <h4> Formdan Gelen Kullanıcı Başvuruları</h4>
          <div className="talep-filters">
           <input
             type="text"
             placeholder="Arama "
             value={nameFilter}
             onChange={this.handleNameFilterChange}
               style={{
               marginTop: "20px",
               marginLeft: "100px"
                           }}
           />
            <button
              type="button"
              data-toggle="tooltip"
              data-placement="bottom"
              rel="tooltip"
              className="TekBtn search btn-icon sag-1 pull-right"
              style={{
                background: "linear-gradient(rgba(159, 208, 55, 0.6), rgb(159, 208, 55))",
                marginRight: "80px",
                 marginTop: "20px"
              }}
              onClick={this.handleFilter}
            >
              Arama Yap
            </button>
            <button
              type="button"
              className="TekBtn delete btn-icon"
              style={{ background: "rgb(243, 157, 157)", marginLeft: "9px" ,
              right:"80px", marginTop: "20px"
              }}
              onClick={this.clearNameFilter}
            >
              Tümünü Temizle
            </button>
          </div>

        <div className="talepler">
        {loading && <p>Loading...</p>}
        {error && <p className="error-message">{error}</p>}
        {wpUserList.length > 0 ? (
        <table className="nobettableclass">
            <thead>
            <tr>
                <th>vknTckn</th>
                <th>email</th>
                <th>Durum</th>
                <th>İşlemler</th>
            </tr>
            </thead>
            <tbody>
            {wpUserList.map((wpUserList, index) => (
           <tr key={index}>
        <td>{wpUserList.vknTckn}</td>
        <td>{wpUserList.email}</td>
        <td>
            {wpUserList.wpUserStatus === "ONAYLA" ? "Onaylandı" : wpUserList.wpUserStatus === "REDDET" ? "Reddedildi" : "Beklemede"}
        </td>
        <td>
            <div className="dropdown">
                <button className="btn btn-secondary dropdown-toggle talepcustom-dropdown-button" type="button"
                        id={`actions-dropdown-${wpUserList.id}`} data-toggle="dropdown" aria-haspopup="true"
                        aria-expanded="false">
                    İşlemler
                </button>
                <div className="dropdown-menu" aria-labelledby={`actions-dropdown-${wpUserList.id}`}>
                <button className="dropdown-item" onClick={() => this.handleUpdateWpUserStatus(wpUserList.id, "ONAYLA")}>
                Onayla
            </button>
            <button className="dropdown-item" onClick={() => this.handleUpdateWpUserStatus(wpUserList.id, "REDDET")}>
                Reddet
            </button>
                    <button className="dropdown-item" onClick={() => this.handleDeleteWpUser(wpUserList.id)}>
                        Sil
                    </button>
                   </div>
                 </div>
                  </td>
               </tr>
                ))}
            </tbody>

           </table>
              ) : (
           <p>Henüz başvuran kullanıcı yok.</p>
             )}
          </div>
            <button type="button" onClick={this.handleUserFormOpen} className="nobet-talep-button">
            KULLANICI OLUŞTUR
          </button>
          {this.state.isUserFormOpen && (
          <UserForm onCancel={this.handleUserFormClose} />
        )}    
         </div>
    );}
          }

 export default WpUserList;


// WEBPACK FOOTER //
// ./src/page/wpuser/WpUserList.js